import { SubscriptionApi } from './subscription.api';
import { SubscriptionProcessApi } from './subscriptionProcess.api';

const subscriptionApi = new SubscriptionApi();
const subscriptionProcessApi = new SubscriptionProcessApi()

export { subscriptionApi, subscriptionProcessApi };
